import React, { Component, useEffect, useState } from 'react';
import { Pagination, Icon } from 'antd';
import { Link } from 'react-router-dom';
import Flag from '../../components/Flag';
import { API_URL, EXCHANGE_S3_IMAGE } from '../../config/constants';
import { getCountry } from '../../common/utils';
import { pickRandomImage } from '../Project/Project';

const ProjectCard = ({ data, stat, randomImage }) => {
	const [selectedPicture, setselectedPicture] = useState({ backgroundImage: randomImage });

	useEffect(() => {
		if (data.info.public && data.info.public.banner) {
			if (API_URL.includes('testnet')) {
				setselectedPicture({
					backgroundImage: `url(${EXCHANGE_S3_IMAGE('banner', data.name)})`
				})
			} else {
				setselectedPicture({
					backgroundImage: `url(${data.info.public.banner})`
				})
			}
		} else {
			setselectedPicture({ backgroundImage: randomImage })
		}
	}, [data, randomImage])

	let country = getCountry(data.info, true);

	const public_title = data.info.public
		? data.info.public.name
			? data.info.public.name
			: data.info.public.title
		: '';
	return (
		<div className="project-card">
			<div className="project-card-banner" style={selectedPicture}>
				{data.is_collateralized && <Flag className="size" />}
			</div>
			<div className="project-card-info">
				<h4>{public_title}</h4>
				
				<p>
					{country === '' ? (
						<span>
							<Icon
								type="global"
								style={{ fontSize: '11px', color: '#40A9FF' }}
							/>
							&nbsp;Global
						</span>
					) : (
						country
					)}
				</p>
				<Link to={`/project/${data.id}`}>View Project</Link>
			</div>
		</div>
	);
};

class OtherProjects extends Component {
	state = {
		current: 1,
		isMobile: false
	};

	componentDidMount() {
		this.handleSize();
		window.addEventListener('resize', this.handleSize);
	}

	handleSize = () => {
		const { isMobile } = this.state;
		if (window.innerWidth <= 1200 && !isMobile) {
			this.setState({ isMobile: true });
		} else if (window.innerWidth > 1200 && isMobile) {
			this.setState({ isMobile: false });
		}
	};

	onChange = (v) => {
		this.setState({ current: v });
	};

	render() {
		const { data, stat } = this.props;
		const { current, isMobile } = this.state;
		if (data.length <= 1) return null;
		const List = data.map((item, index) => {
			if (index === 0) return null;
			if (isMobile) {
				return <ProjectCard data={item} key={index} stat={stat} randomImage={pickRandomImage(item.id)} />;
			} else {
				if ((current - 1) * 3 < index && current * 3 >= index) {
					return <ProjectCard data={item} key={index} stat={stat} randomImage={pickRandomImage(item.id)} />;
				} else {
					return null;
				}
			}
		});
		return (
			<div className="other-project">
				<div className='other-project-wrapper'>
					<h3>Other Project</h3>
					{List}
				</div>
				{isMobile ? null : (
					<Pagination
						current={this.state.current}
						onChange={this.onChange}
						defaultPageSize={3}
						total={data.length - 1}
					/>
				)}
			</div>
		);
	}
}

export default OtherProjects;
